// file src/constants/student.constants.ts
export const studentConstants = {
    GETALL_REQUEST: 'STUDENTS_GETALL_REQUEST',
    GETALL_SUCCESS: 'STUDENTS_GETALL_SUCCESS',
    GETALL_FAILURE: 'STUDENTS_GETALL_FAILURE',
  
    DELETE_REQUEST: 'STUDENT_DELETE_REQUEST',
    DELETE_SUCCESS: 'STUDENT_DELETE_SUCCESS',
    DELETE_FAILURE: 'STUDENT_DELETE_FAILURE',

    CREATE_REQUEST: 'STUDENT_CREATE_REQUEST',
    CREATE_SUCCESS: 'STUDENT_CREATE_SUCCESS',
    CREATE_FAILURE: 'STUDENT_CREATE_FAILURE',

    UPDATE_REQUEST: 'STUDENT_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'STUDENT_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'STUDENT_UPDATE_FAILURE',
    
    GET_BY_ID_REQUEST: 'STUDENT_GETBYID_REQUEST',
    GET_BY_ID_SUCCESS: 'STUDENT_GETBYID_SUCCESS',
    GET_BY_ID_FAILURE: 'STUDENT_GETBYID_FAILURE',

    ADD_FROM_GG_SHEET_REQUEST: 'ADD_STUDENT_LIST_FROM_GG_SHEET_REQUEST',
    ADD_FROM_GG_SHEET_SUCCESS: 'ADD_STUDENT_LIST_FROM_GG_SHEET_SUCCESS',
    ADD_FROM_GG_SHEET_FAILURE: 'ADD_STUDENT_LIST_FROM_GG_SHEET_FAILURE',

};
